import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useUserRole } from "@/hooks/useUserRole";

const SESSION_FLAG = "sitemap-gsc-submitted";

/**
 * On mount for authenticated admins, invoke the submit-sitemap-gsc edge
 * function once per browser session. The function is idempotent: it hashes
 * the deployed sitemap.xml and no-ops if unchanged since the last successful
 * submission. This is how "resubmit after a successful publish or route
 * change" is triggered — the fresh publish serves a new sitemap.xml, the
 * hash differs, and Google is notified. A daily pg_cron acts as a safety
 * net for long-idle deployments.
 */
export function SitemapAutoSubmit() {
  const { isAdmin, loading } = useUserRole();

  useEffect(() => {
    if (loading || !isAdmin) return;
    if (typeof window === "undefined") return;
    try {
      if (sessionStorage.getItem(SESSION_FLAG) === "1") return;
      sessionStorage.setItem(SESSION_FLAG, "1");
    } catch {
      // sessionStorage blocked; still safe to call — function dedupes by hash.
    }

    void supabase.functions
      .invoke("submit-sitemap-gsc", { body: { trigger: "client-bootstrap" } })
      .then(({ data, error }) => {
        if (error) {
          console.warn("[sitemap-gsc] submit failed", error);
        } else if (data?.submitted) {
          console.info("[sitemap-gsc] submitted", data);
        }
      });
  }, [isAdmin, loading]);

  return null;
}
